import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Drawer from "./Components/Drawer/Drawer";
import RoutesConfig from "./Routes/RoutesConfig";
import "./App.css";
import Config from "./config";
import axios from "axios";
import EncryptionUtils from "./Utils/EncryptionUtils";
import { LicenseInfo } from "@mui/x-license";
import LanguageButton from "./Components/Generic/LanguageButton";
import { useTranslation } from "react-i18next";

export default function App(props) {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const { config } = props;
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { i18n } = useTranslation();

  LicenseInfo.setLicenseKey(
    "e0d9bb8070ce0054c9d9ecb6e82cb58fTz0wLEU9MzI0NzIxNDQwMDAwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y"
  );

  useEffect(() => {
    const storedUser = JSON.parse(EncryptionUtils.getDecryptedData("user"));
    if (storedUser) {
      setUser(storedUser);
      setIsAuthenticated(true);
      setDrawerOpen(true);
      
      // Configurar el idioma del usuario guardado
      const savedLanguage = localStorage.getItem("language");
      if (savedLanguage) {
        // console.log('App - Cargando idioma guardado:', savedLanguage);
        i18n.changeLanguage(savedLanguage);
      } else if (storedUser.idLanguage) {
        // Si no hay idioma guardado, usar el del usuario
        const userLanguage = storedUser.idLanguage;
        const idiomaBase = userLanguage === 1 ? "es" : "en";
        // console.log('App - Configurando idioma por ID del usuario guardado:', idiomaBase);
        localStorage.setItem("language", idiomaBase);
        i18n.changeLanguage(idiomaBase);
      }
    }
  }, []);

  useEffect(() => {
    const userLogin =
      user ?? JSON.parse(EncryptionUtils.getDecryptedData("user"));

    if (userLogin != null && userLogin.user != null) {
      const userPermissions = userLogin?.user.permisosWebUsuarios || [];
      const itemsPermissions = userPermissions.filter(
        (permiso) => permiso?.estatus
      );
      setPermissions(itemsPermissions);
    } else {
      handleLogout();
    }
  }, [user]);

  const handleLogin = (username) => {
    setUser(username);
    setIsAuthenticated(true);
    setDrawerOpen(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
    setUser(null);
    axios.defaults.headers.common["Authorization"] = "";
    localStorage.clear();
    setDrawerOpen(false);
  };

  // Función para manejar el cambio de idioma
  const handleLanguageChange = (updatedUserData) => {
    // console.log('App.jsx - Permisos actualizados del API:', updatedUserData?.user.permisosWebUsuarios);
    setUser(updatedUserData);
    // Recargar permisos con el nuevo idioma
    const userPermissions = updatedUserData?.user.permisosWebUsuarios || [];
    const itemsPermissions = userPermissions.filter(
      (permiso) => permiso?.estatus
    );
    setPermissions(itemsPermissions);
  };

  return (
    <Router basename={Config.basename}>
      <div
        className="app-container"
        style={{
          backgroundColor: user ? "#F0F2F5" : "#07468E",
        }}
      >
        {user && (
          <Drawer
            user={user}
            onLogout={handleLogout}
            drawerOpen={drawerOpen}
            setDrawerOpen={setDrawerOpen}
            config={config}
            permissions={permissions}
          />
        )}
        <div
          className="content-container"
          style={{ padding: "20px", marginLeft: drawerOpen ? "280px" : "0" }}
        >
          {/* Botón de cambio de idioma - alineado con el Card */}
          {user && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "10px",
                marginTop: "5px",
              }}
            >
              <LanguageButton config={config} onLanguageChange={handleLanguageChange} />
            </div>
          )}
          <RoutesConfig
            user={user}
            handleLogin={handleLogin}
            permissions={permissions}
            config={config}
            isAuthenticated={isAuthenticated}
          />
        </div>
      </div>
    </Router>
  );
}
